import React from 'react'
import {useTranslation} from 'react-i18next'

import Page from 'src/designSystem/components/organisms/Page/Page'
import {IDScanCapturePhases, IDScanProps} from 'src/products/loans/IDScan/IDScan.types'
import {IDScanCaptureTemplate} from 'src/products/loans/IDScan/IDScanCaptureTemplate'

export const IDScanTemplate = ({
  onImageSubmitStart: handleOnImageSubmitStart,
  onImageSubmitComplete: handleOnImageSubmitComplete,
  onContinue: handleOnContinue,
  busy,
  phase,
  error,
  processingStatus,
  clearErrors,
}: IDScanProps): JSX.Element => {
  const {t} = useTranslation(['IDScan', 'Common'])

  switch (phase) {
    case IDScanCapturePhases.ImageCapture:
      return (
        <IDScanCaptureTemplate
          onImageSubmitStart={handleOnImageSubmitStart}
          onImageSubmitComplete={handleOnImageSubmitComplete}
          onContinue={handleOnContinue}
          error={error}
          processingStatus={processingStatus}
          clearErrors={clearErrors}
          busy={busy}
        />
      )
    case IDScanCapturePhases.ImageCaptured:
      // This screen only appears when the user has already uploaded an image (ex if they hit the back button)
      return (
        <Page
          variant="generic"
          buttonProps={{
            type: 'singleButton',
            primary: {
              text: t('Common:Continue'),
              onPress: handleOnContinue,
              loading: busy,
              disabled: busy,
              testID: 'continueTestId',
            },
          }}
          title={t('IDCaptured')}
          testID="IDScanCompleteTemplate"
        />
      )
  }
}
